export default __webpack_public_path__ + "static/icon-Languages-85ea47203a2226d231ea10a539051525.svg";